import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

interface TrainerDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
}

const TrainerDialog: React.FC<TrainerDialogProps> = ({ open, onClose, onSave }) => {
  const [name, setName] = useState('');

  const handleSave = () => {
    if (name.trim()) {
      onSave(name.trim());
      setName('');
    }
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>New Trainer</DialogTitle>
      <DialogContent>
        <TextField
          label="Trainer Name"
          value={name}
          onChange={e => setName(e.target.value)}
          fullWidth
          autoFocus
          margin="dense"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={!name.trim()}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrainerDialog;
